module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hR8E5"))).then(() => parcelRequire('hEqeo'));